import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeContext } from 'styled-components';

import * as productActions from '@actions/products';
import * as productSelectors from '@selectors/products';

import * as Icons from '@common/components/Icons';
import { LAYOUT_COLUMN, LAYOUT_GRID } from '@common/constants/ui';

import {
  Container,
  CustomButton,
  CustomButtons,
  FloatingContainer,
} from './LayoutSwitcher.styled';

export function LayoutSwitcher() {
  const dispatch = useDispatch();
  const themeContext = useContext(ThemeContext);
  const layoutPreference = useSelector(productSelectors.selectLayoutPreference);
  const activeFill = themeContext.colors.bluegrey[15];
  const inActiveFill = themeContext.colors.bluegrey[70];

  return (
    <Container>
      <FloatingContainer>
        <CustomButtons>
          <CustomButton
            onClick={() =>
              dispatch(productActions.setLayoutPreference(LAYOUT_GRID))
            }
          >
            <Icons.GridLayout
              fill={
                layoutPreference === LAYOUT_GRID ? activeFill : inActiveFill
              }
            />
          </CustomButton>
          <CustomButton
            onClick={() =>
              dispatch(productActions.setLayoutPreference(LAYOUT_COLUMN))
            }
          >
            <Icons.LayoutColumn
              fill={
                layoutPreference === LAYOUT_COLUMN ? activeFill : inActiveFill
              }
            />
          </CustomButton>
        </CustomButtons>
      </FloatingContainer>
    </Container>
  );
}

export default LayoutSwitcher;
